/* SAVA free gifts (BF 2026): keeps exactly one of each free gift (bonus bracelet, gift packaging) in the cart
   while the cart holds at least one other item. Gifts carry the hidden property _sava_gift, so the cart
   shows them as gifts and leaves them out of the BOGO count. Config comes from snippets/sava-free-gifts.liquid.
   Runs on page load and after every cart request (add / change / update / clear) the page makes,
   then re-renders the drawer (and the cart page) without opening the drawer.
   Checkout buttons wait for a fresh check first, so a cart with only gifts never reaches checkout from the theme. */
(() => {
  const cfg = window.savaFreeGifts;
  if (!cfg || !cfg.items || !cfg.items.length || window.savaFreeGiftsOn) return;
  window.savaFreeGiftsOn = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const giftIds = cfg.items.map((g) => g.variant);
  const skip = cfg.notCounting || [];

  let busy = false;
  let again = false;
  let timer = null;
  let passed = false;

  const sections = () => {
    const d = document.querySelector('cart-drawer');
    return d && d.getSectionsToRender ? d.getSectionsToRender().map((s) => s.section) : [];
  };

  const render = (res) => {
    const d = document.querySelector('cart-drawer');
    if (d && d.renderContents && res.sections) d.renderContents(res, false);
    else if (document.getElementById('main-cart-items')) location.reload();
  };

  const post = (url, body) =>
    fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Sava-Gifts': '1' },
      body: JSON.stringify(Object.assign(body, { sections: sections(), sections_url: location.pathname })),
    }).then((r) => r.json());

  const sync = async () => {
    if (busy) {
      again = true; // a cart request came in during this check: look once more afterwards
      return;
    }
    busy = true;
    let rest;
    try {
      const cart = await fetch(root + 'cart.js', { headers: { 'X-Sava-Gifts': '1' } }).then((r) => r.json());
      // Gifts only with at least one real item: not a gift, not a gift card, not insurance/spooky etc.
      const others = cart.items.filter(
        (i) => !giftIds.includes(i.variant_id) && !(i.properties && i.properties._sava_gift) && !i.gift_card && !skip.includes(i.product_id)
      ).length;
      const want = others > 0 ? 1 : 0;
      rest = cart.items.filter(
        (i) => !giftIds.includes(i.variant_id) && !(i.properties && i.properties._sava_gift) && i.product_id !== cfg.insurance
      ).length;
      let res = null;
      const add = [];
      for (const g of cfg.items) {
        const lines = cart.items.filter((i) => i.variant_id === g.variant);
        const have = lines.reduce((n, i) => n + i.quantity, 0);
        if (have === want) continue;
        if (have === 0) {
          add.push({ id: g.variant, quantity: 1, properties: { _sava_gift: g.kind } });
          continue;
        }
        res = await post('cart/change.js', { id: lines[0].key, quantity: want });
        if (res && res.status) res = null; // e.g. sold out / product not available: leave the cart as it is
      }
      // Both gifts in one request (one server round, one render). One sold out fails the request: then one by one
      if (add.length) {
        res = await post('cart/add.js', { items: add });
        if (res && res.status) {
          res = null;
          if (add.length > 1) {
            for (const item of add) {
              const one = await post('cart/add.js', { items: [item] });
              if (one && !one.status) res = one;
            }
          }
        }
      }
      if (res) render(res);
    } catch (e) {
      console.error('sava-free-gifts', e);
    } finally {
      busy = false;
      if (again) {
        again = false;
        later();
      }
    }
    return rest;
  };

  const later = () => {
    clearTimeout(timer);
    timer = setTimeout(sync, 50);
  };

  // Checkout: check the cart first. Nothing left but gifts and insurance (checkout adds that line to the cart)
  // = the cart is emptied and the customer stays on the page.
  // If the check itself fails, checkout goes on as normal.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!btn || passed) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    clearTimeout(timer);
    while (busy) await new Promise((r) => setTimeout(r, 50));
    const rest = await sync();
    if (rest === 0) {
      await post('cart/clear.js', {}).catch(() => {});
      location.reload();
      return;
    }
    passed = true;
    btn.click();
    passed = false;
  }, true);

  // Watch the page's own cart requests (theme, picker, apps); ignore our own
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const p = origFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const own = init && init.headers && (init.headers['X-Sava-Gifts'] || (init.headers.get && init.headers.get('X-Sava-Gifts')));
      if (!own && /\/cart\/(add|change|update|clear)/.test(url)) p.then(later, () => {});
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();
  window.addEventListener('pageshow', (e) => { if (e.persisted) later(); });
})();
